import { useTheme as styledUseTheme } from 'styled-components';
import Theme from './types/theme';

const useTheme = (): Theme => {
  const theme = styledUseTheme();
  return theme as Theme;
};

export default useTheme;
